import React from 'react';
import { ExternalLink } from 'lucide-react';

const LEHODEY_URL = 'https://doi.org/10.1038/39575';

const ConvergenceZoneMethodology = () => (
    <section className="rounded-xl border border-cyan-500/20 bg-cyan-950/20 p-4">
        <h4 className="text-sm font-semibold text-cyan-100">29°C convergence-zone proxy</h4>
        <p className="mt-2 text-sm leading-6 text-slate-300">
            The line-only overlay follows the 29°C sea-surface-temperature isotherm as a proxy for the
            western Pacific warm-pool convergence zone. Lehodey et al. (1997) reported that movement of
            this isotherm was highly correlated with the salinity front and with convergence inferred from
            drifter trajectories. It is an oceanographic proxy, not a direct atmospheric convergence diagnostic.
        </p>
        <a
            className="mt-3 inline-flex items-center gap-2 text-sm text-cyan-300 underline decoration-cyan-500/60 underline-offset-4 hover:text-cyan-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-cyan-300"
            href={LEHODEY_URL}
            target="_blank"
            rel="noopener noreferrer"
        >
            <ExternalLink aria-hidden="true" size={15} />
            Lehodey et al. (1997), Nature 389, 715–718
        </a>
        <p className="mt-3 text-xs leading-5 text-slate-400">
            Current lines use the selected SST source and valid time. The monthly reference line uses NOAA
            OISST v2.1 over the 1991–2020 climatology period.
        </p>
    </section>
);

export default ConvergenceZoneMethodology;
